import React, { useState, useContext, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import DatePicker from 'react-datepicker';
import toast from 'react-hot-toast';
import { FaArrowUpShortWide, FaArrowDownWideShort } from 'react-icons/fa6';
import Cookies from 'js-cookie';
import { Modal } from 'react-bootstrap';
import { Button } from '@/shared/components/Button';
import { PiCaretUpDownFill } from 'react-icons/pi';
import { AuthContext } from '../../../../../context/AuthContext';
import 'react-datepicker/dist/react-datepicker.css';
import BookingInfo from './BookingInfo';
import AddAmount from './AddAmount';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';


const LedgerTable = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [dateShow, setDateShow] = useState(false);
  const [bookingDetailsModal, setBookingDetailsModal] = useState(false);
  const [showAddAmountModal, setShowAddAmountModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [bookingData, setBookingData] = useState([]);
  const {
 apiGlobal, restaurantid, currencyCode, countryId, 
} = useContext(AuthContext);
  const [bookingID, setBookingID] = useState(); // hold actual booking id while showing info
  const [bookingID2, setBookingID2] = useState(); // hold id of booking info to show in modal
 const [payInfo, setPayInfo] = useState({});
 const { sideBarRefresh } = useContext(SideBarRefreshContext);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  const [sortOrder, setSortOrder] = useState('asc');
  const [sortColumn, setSortColumn] = useState('payment_date'); // This will track the column being sorted
 
const handleSort = (column) => {
  const newSortOrder = sortColumn === column 
  && sortOrder === 'asc' ? 'desc' : 'asc'; // Toggle order for the same column
  const sortedData = [...bookingData].sort((a, b) => {
    if (column === 'payment_date') {
      return newSortOrder === 'asc'
        ? a.payment_date.localeCompare(b.payment_date)
        : b.payment_date.localeCompare(a.payment_date);
        // eslint-disable-next-line
    } else if (column === 'payment_type') {
      return newSortOrder === 'asc'
        ? a.payment_type.localeCompare(b.payment_type)
        : b.payment_type.localeCompare(a.payment_type);
    } else if (column === 'balance') {
      return newSortOrder === 'asc' 
      ? parseFloat(a.balance) - parseFloat(b.balance) 
      : parseFloat(b.balance) - parseFloat(a.balance);
    }
    return 0;
  });
 
  setBookingData(sortedData);
  setSortOrder(newSortOrder);
  setSortColumn(column); // Update the current sorted column
};


  const rangeHandler = (e) => {
    setDateShow(e.target.checked);
  };

  // console.log(useSelector(state => state));


  const fetchBookingData = async () => {
    const formdata = new FormData();
    formdata.append('restaurant_id', restaurantid);
        formdata.append('country_id', countryId);


    try {
      const url = await fetch(`${apiGlobal}/restaurant/account_data.php`, {
        method: 'POST',
        body: formdata,
      });
      const response = await url.json();
      // console.log(response);
      if (response?.status && response?.message === 'Success') {
        setBookingData(response?.data);
      } else {
        console.log(response.message);
        setBookingData([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBookingData();
  }, [restaurantid, refresh, sideBarRefresh?.restaurantAccountRefresh]);

  const bookingDetailsHandler = (bookingid, id) => {
    setBookingID(bookingid);
    setBookingID2(id);
    setBookingDetailsModal(true);
  };

  const normalizeDate = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };
  
  const filteredBookingData = dateShow
    ? bookingData.filter((booking) => {
        const paymentDate = normalizeDate(booking.payment_date);
        const start = normalizeDate(startDate);
        const end = normalizeDate(endDate);
        return paymentDate >= start && paymentDate <= end;
      })
    : bookingData;

  // Calculate totals based on filtered data
  const totalCredit = filteredBookingData.reduce((sum, item) => sum + (parseFloat(item.cr_amount) || 0), 0);
  const totalDebit = filteredBookingData.reduce((sum, item) => sum + (parseFloat(item.dr_amount) || 0), 0);
  const finalBalance = filteredBookingData.reduce((sum, item) => sum + (parseFloat(item.balance) || 0), 0);

  
  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  
    // Slice data for the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredBookingData.slice(indexOfFirstItem, indexOfLastItem);
  
    // Total pages
    const totalPages = Math.ceil(filteredBookingData.length / itemsPerPage);
    const myCookie = Cookies.get('_LMAMU_AK_');


  return (
    <div>
      <div className="ledger-container">
        {/* Topbar Section */}
        <div className="topbar">
          <div className="filter">
            <Form.Check 
              type="checkbox" 
              id="checkBox" 
              label="Date Range" 
              onChange={rangeHandler} 
              style={{
            margin: '10px',
           }}
            />
            <div className="date-picker-group">
              <label htmlFor="startDate">Start Date<span className="required">*</span></label>
              <DatePicker
                selected={startDate}
                onChange={setStartDate}
                dateFormat="dd-MM-yyyy"
                disabled={!dateShow}
                id="startDate"
                maxDate={endDate}
              />
            </div>
            <div className="date-picker-group">
              <label htmlFor="endDate">End Date<span className="required">*</span></label>
              <DatePicker
                selected={endDate}
                onChange={setEndDate}
                dateFormat="dd-MM-yyyy"
                disabled={!dateShow}
                id="endDate"
                minDate={startDate}
              />
            </div>
            <Button
              variant="outline-danger"
              style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '2px',
            alignSelf: 'center',
          }}
              className="mt-5"
              onClick={() => {
            setRefresh(prev => !prev);
            toast.success('Data refreshed successfully');
          }}
            >
              Refresh
            </Button>
          </div>
        </div>

        {/* Table Section */}
        <div className="table-container">
          {filteredBookingData.length === 0 ? (
            <div className="no-data-message">
              {dateShow 
              ? `No Account found between ${startDate.toLocaleDateString()} and ${endDate.toLocaleDateString()}`
              : 'No Account found'}
            </div>
        ) : (
          <Table responsive className="custom-table">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th onClick={() => handleSort('payment_date')} style={{ cursor: 'pointer' }}>
                  <PiCaretUpDownFill /> Date {sortColumn === 'payment_date' 
                  && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
                </th>
                <th>Particular</th>
                <th onClick={() => handleSort('payment_type')} style={{ cursor: 'pointer' }}>
                  Payment Type {sortColumn === 'payment_type' 
                  && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
                </th>
                <th>Credit</th>
                <th>Debit</th>
                <th onClick={() => handleSort('balance')} style={{ cursor: 'pointer' }}>
                  <PiCaretUpDownFill /> Balance {sortColumn === 'balance' 
                  && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredBookingData.map((booking, index) => (
                <tr key={booking.id}>
                  <td>{index + 1}</td>
                  <td>{formatDate(booking.payment_date)}</td>
                  <td>{booking.booking === '1' ? 'Meal Booked' : 'Transfer'}</td>
                  <td>
                    {booking.booking !== '1' ? ((() => {
                    switch (booking.payment_type) {
                      case '1':
                        return 'Cash';
                      case '2':
                        return 'online';
                      case '3':
                        return 'NEFT/RTGS/IMPS';
                      case '4':
                        return 'On Account';
                      case '5':
                        return 'Cheque';
                      default:
                        return 'Unknown'; // Fallback if none of the conditions match
                    }
                  })()) : '-'}
                  </td>
                  <td>{booking.cr_amount 
                  ? `${parseFloat(booking.cr_amount).toLocaleString()}  ` : '-'}
                  </td>
                  <td>{booking.dr_amount 
                  ? `${parseFloat(booking.dr_amount).toLocaleString()}  ` : '-'}
                  </td>
                  <td>{(booking.balance)} </td>
                  {/* <td>{(booking.balance)} {currencyCode} </td> */}
                  <td>
                    {booking.booking === '1' && (
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => bookingDetailsHandler(booking.booking_id, booking.id)}
                      >
                        Book info
                      </Button>
                    )}
                    {booking.booking !== '1' && (
                    <Button
                      variant="outline-warning"
                      size="sm"
                      onClick={() => setPayInfo({
                        showModal: true,
                        paytype: booking.payment_type || 'NA',
                        paymentDate: booking.payment_date || 'NA',
                        paymentAmount: booking.in_amount || 'NA',
                        totalAmount: booking.total_amount || 'NA',
                        refNo: booking.ref_no || 'NA',
                        narration: booking.narration || 'NA',
                        bankName: booking.bank || 'NA',
                        chequeDate: booking.ref_date || 'NA',
                       })}
                    >
                      Pay info
                    </Button>
                   )}
                    
                    
                  </td>
                </tr>
              ))}
              <td />
            </tbody>
            <tfoot className="bg-success text-white">
              <tr>
                <td colSpan="4"><strong>Total</strong></td>

                <td><strong>₹{totalCredit.toLocaleString()}</strong></td>
                <td><strong>₹{totalDebit.toLocaleString()}</strong></td>
                <td><strong /></td>
                <td />
              </tr>
            </tfoot>
          </Table>
        )}
          {/* Pagination Controls */}
          {/* <div style={{
        marginTop: '12px',
        bottom: '20px', 
        right: '20px', 
        zIndex: 999, 
        display: 'flex', 
        justifyContent: 'flex-end', 
        alignItems: 'center',
      }}
          >
            <Pagination>
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {Array.from({ length: totalPages }, (_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === currentPage}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
          ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div> */}
        </div>
      


        {/* Modal */}
        <Modal
          show={bookingDetailsModal}
          onHide={() => setBookingDetailsModal(false)}
          centered
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Booking Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BookingInfo bookingID={bookingID} id={bookingID2} />
          </Modal.Body>
        </Modal>

        {/* Modal */}
        <Modal
          show={showAddAmountModal}
          onHide={() => setShowAddAmountModal(false)}
          centered
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Amount</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddAmount setShowAddAmountModal={setShowAddAmountModal} />
          </Modal.Body>
        </Modal>
        {/* Modal for showing payment Info */}
        <Modal
          show={payInfo?.showModal}
          onHide={() => setPayInfo({
            showModal: false,
            paytype: '',
            paymentDate: '',
            paymentAmount: '',
            totalAmount: '',
            refNo: '',
            narration: '',
            bankName: '',
            chequeDate: '',
          })}
          centered
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Payment Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table
              responsive
              style={{
            backgroundColor: '#f9f9f9',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(178, 114, 114, 0.1)',
        }}
            >
              <thead className="bg-primary" style={{ color: 'white', textAlign: 'center' }}>
                <tr>
                  <th>#</th>
                  <th>Payment Date</th>
                  <th>Payment Type</th>
                  <th>Payment Amount</th>
                  <th>Narration</th>
                  <th>Ref No</th>
                  <th>Bank Name</th>
                  <th>Cheque Date</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: 'center' }}>
                <tr>
                  <td>{1}</td>
                  <td>{formatDate(payInfo.paymentDate)}</td>
                  <td>
                    {(() => {
                switch (payInfo.paytype) {
                  case '1':
                    return 'Cash';
                  case '3':
                    return 'NEFT/RTGS/IMPS';
                  case '4':
                    return 'On Account';
                  case '5':
                    return 'Cheque';
                  default:
                    return 'Unknown Payment Method';
                }
              })()}
                  </td>
                  <td>{payInfo.paymentAmount}</td>
                  <td>{payInfo.narration}</td>
                  <td>{payInfo.paytype !== '1' ? payInfo.refNo : 'NA'}</td>
                  <td>{payInfo.paytype === '3' || payInfo.paytype === '5' ? payInfo.bankName : 'NA'}</td>
                  <td> {payInfo.paytype === '5' ? formatDate(payInfo.chequeDate) : 'NA'}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
        </Modal>

        {/* Styles */}
        <style jsx>{`
        .ledger-container {
          padding: 20px;
          background-color: #f8f9fa;
          min-height: 100vh;
        }

        .topbar {
          background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          margin-bottom: 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 20px;
        }

        .filter {
          display: flex;
          align-items: center;
          gap: 20px;
          flex-wrap: wrap;
          padding: 15px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
        }

        .date-picker-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .date-picker-group label {
          font-size: 14px;
          font-weight: 500;
          color: #495057;
        }

        .required {
          color: red;
          margin-left: 4px;
        }

        .date-picker-group input {
          padding: 8px 12px;
          border: 1px solid #dee2e6;
          border-radius: 6px;
          font-size: 14px;
          color: #495057;
          transition: all 0.2s ease;
          min-width: 130px;
          background-color: white;
        }

        .date-picker-group input:focus {
          outline: none;
          border-color: #4dabf7;
          box-shadow: 0 0 0 3px rgba(77, 171, 247, 0.1);
        }

        .date-picker-group input:disabled {
          background-color: #e9ecef;
          cursor: not-allowed;
        }

        .wallet-amount {
          background: white;
          padding: 15px 25px;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
        }

        .wallet-amount h3 {
          margin: 0;
          color: #2b3674;
          font-size: 20px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .wallet-amount span {
          color: #4318FF;
        }

        .filter-info {
          margin: 8px 0 0;
          font-size: 14px;
          color: #6c757d;
        }

        .filter input[type="checkbox"] {
          width: 18px;
          height: 18px;
          margin-right: 8px;
          accent-color: #4318FF;
        }

        .filter label {
          font-size: 14px;
          font-weight: 500;
          color: #495057;
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .table-container {
          width: 100%;
          overflow-x: auto;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          padding: 20px;
        }

        .custom-table {
          margin: 0;
        }

        .custom-table thead {
          background-color: #4318FF;
        }

        .custom-table thead th {
          color: white;
          font-weight: 500;
          padding: 12px;
          text-align: center;
          border: none;
        }

        .custom-table tbody tr {
          transition: background-color 0.2s ease;
        }

        .custom-table tbody tr:nth-child(even) {
          background-color: #f8f9fa;
        }

        .custom-table tbody tr:hover {
          background-color: #e9ecef;
        }

        .custom-table tbody td {
          padding: 12px;
          text-align: center;
          vertical-align: middle;
          border-bottom: 1px solid #dee2e6;
        }

        .custom-table tfoot {
          font-weight: bold;
          background-color: #f8f9fa;
        }

        .custom-table tfoot td {
          padding: 12px;
          text-align: center;
          border-top: 2px solid #dee2e6;
        }

        .no-data-message {
          color: #dc3545;
          text-align: center;
          font-size: 16px;
          padding: 30px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }

        @media (max-width: 768px) {
          .topbar {
            padding: 15px;
            flex-direction: column;
            align-items: stretch;
          }

          .filter {
            width: 100%;
            justify-content: flex-start;
          }

          .wallet-amount {
            width: 100%;
            text-align: center;
          }

          .wallet-amount h3 {
            justify-content: center;
          }
        }

        @media (max-width: 576px) {
          .filter {
            flex-direction: column;
            align-items: stretch;
            gap: 15px;
          }

          .date-picker-group {
            width: 100%;
          }

          .date-picker-group input {
            width: 100%;
          }

          .ledger-container {
            padding: 10px;
          }

          .table-container {
            padding: 10px;
          }
        }
      `}
        </style>
      </div>
    </div>
  
  );
};

// LedgerTable.propTypes = {
//   agentId: PropTypes.string.isRequired,
// };

export default LedgerTable;
